export default {
  isAdjusting: state => state.isAdjusting,
  isPrinting: state => state.isPrinting,

  paperSize: state => state.paperSize,
  paperOrientation: state => state.paperOrientation
}
